var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiscountTiny(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b52025",
    d: "M9 1.5L11.4 0l1.3 2.5 2.9-.1-.1 2.9L18 6.6 16.5 9l1.5 2.4-2.5 1.3.1 2.9-2.9-.1-1.3 2.5L9 16.5 6.6 18l-1.3-2.5-2.9.1.1-2.9L0 11.4 1.5 9 0 6.6l2.5-1.3-.1-2.9 2.9.1L6.6 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7 9.2c-.3-.5-.5-1.1-.5-2 0-.8.2-1.5.5-1.9.4-.4.8-.6 1.5-.6.6 0 1.1.2 1.5.6.3.5.5 1.1.5 1.9 0 .8-.2 1.5-.5 1.9-.4.5-.9.7-1.5.7s-1.1-.2-1.5-.6zm2.4-.5c.2-.3.3-.8.3-1.4 0-.6-.1-1.1-.3-1.4-.2-.4-.5-.5-.9-.5s-.7.1-.9.4c-.2.3-.2.8-.2 1.4 0 .6.1 1.1.3 1.4.1.4.4.5.8.5s.7-.1.9-.4zm-.4 4.6c-.1 0-.2 0-.3-.1-.1-.1-.1-.2-.1-.3 0-.1 0-.2.1-.3L11 4.9c.1-.2.2-.3.4-.3.1 0 .2 0 .3.1.1.1.1.2.1.3 0 .1 0 .2-.1.3l-4.5 7.8c-.2.2-.3.2-.5.2zm3.7-.7c-.4-.4-.5-1.1-.5-1.9 0-.8.2-1.5.5-1.9.4-.4.8-.6 1.5-.6.6 0 1.1.2 1.5.6.4.4.5 1.1.5 1.9 0 .8-.2 1.5-.5 1.9-.4.4-.8.6-1.5.6s-1.1-.2-1.5-.6zm2.4-.5c.2-.3.3-.8.3-1.4 0-.6-.1-1.1-.3-1.4-.2-.3-.5-.4-.9-.4s-.7.1-.9.4c-.2.3-.3.8-.3 1.4 0 .6.1 1.1.3 1.4.2.3.5.4.9.4s.7-.1.9-.4z",
    fill: "#fff"
  })));
}

export default SvgDiscountTiny;